<template>
    <div>
        <div class="chat__chats-list mb-8">
            <div class="vx-row w-full items-center justify-between">
                <div>
                    <span class="text-primary pl-8 text-2xl">{{ $t('orders') }}</span>
                </div>
                
                <div>
                    <!-- <a-tooltip :title="$t('deliveryConfigHelp')">
                        <a-icon 
                            class="mr-1 text-danger cursor-pointer" 
                            type="setting" 
                            style="font-size: 24px" 
                            :spin="spin" 
                            @click="openSettings()"  />
                    </a-tooltip> -->
                    <a-tooltip :title="$t('addOrderTip')">
                        <vs-button color="primary" type="border" icon="add"
                            @click="$emit('new-order')">Adicionar</vs-button>
                    </a-tooltip>
                </div>
            </div>

            <vs-divider border-style="dashed" />

            <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('searchOrder')" v-model.lazy="searchText" class="w-full pr-4 pl-4 pb-4" />

            <ul class="chat__active-chats bordered-items">
                <bill-item 
                    class="list-item"
                    v-for="(bill, i) in filteredBills" 
                    :key="bill.id"
                    :stripped="i % 2 == 0" 
                    :id="bill.id"
                    :statusId="bill.status"
                    :orderNumber="bill.startingFrom"
                    :date="bill.openedOn.toDate()"
                    :isSelected="bill.id == selected" 
                    @selected="(val) => selectItem(val)" />
            </ul>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import BillItem from './BillItem'

    export default {
        props : {
            data : {
                type: Array,
                required : true
            }
        },

        components : {
            draggable,
            BillItem
        },

        data  () {
            return {
                spin : true,
                modal : {
                    visible : false
                },
                searchText : '',
                selected : ''
            }
        },

        watch : {
            data () {
                if (this.data.length > 0) {
                    if (!this.selected) this.selectItem(this.filteredBills[0].id)
                }
            }
        },

        computed : {
            filteredBills () {
                return this.data
                           .filter(a => String(a.startingFrom).search(this.searchText) != -1)
                           .sort((a, b) => a.startingFrom - b.startingFrom)
            }
        },

        methods : {
            selectItem (val) {
                this.selected = val
                this.$emit('selected', val)
            },

            openSettings () {
                this.spin = false
                this.modal.visible = true
            }
        }

    }
</script>